<script setup>
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useIcons } from './icons';

const props = defineProps({
    path: {
        type: String,
        required: true
    },
    width: {
        type: String
    },
    height: {
        type: String
    }
});

const icon = ref(null);
const icons = useIcons();

onMounted(async () => {
    if (icons[props.path] === undefined) {
        console.error('Icon not found: ' + props.path);
        return;
    }
    icon.value = await icons[props.path]();
});

const dimensions = computed(() => {
    return {
        ...props.width && { width: props.width },
        ...props.height && { height: props.height }
    }
});

const svgComponent = computed(() => (icon.value) ? defineComponent({ template: icon.value }) : null);
</script>
<template>
    <component v-if="svgComponent" :is="svgComponent" v-bind="dimensions"></component>
</template>